import { Grid, Stack, Stat, Text } from "@chakra-ui/react";
import React, { useRef } from "react";
import { useColorModeValue } from "../ui/color-mode";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const Stats = ({ ...props }) => {
  const secondBg = useColorModeValue("#b8fff7", "#090110");

  const statsText = [
    { label: "ITRs Filed", value: "500", symbol: "+" },
    { label: "Businesses Registered", value: "100", symbol: "+" },
    { label: "Client Satisfaction", value: "95", symbol: "%" },
    { label: "Years of Experience", value: "5", symbol: "+" },
  ];

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <>
      <Stack
        ref={ref}
        bgColor={secondBg}
        px={{ base: "5", md: "20" }}
        py={16}
        textAlign="center"
        gap={14}
        my={10}
        {...props}
        className="fade-section"
        data-scroll
        data-scroll-class="fade-in"
      >
        <Text
          color={{ base: "#008080", _dark: "#66b2b2" }}
          fontSize={{ base: "2xl", md: "3xl" }}
          fontWeight="bold"
        >
          What We’ve Achieved
        </Text>

        <Grid
          templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(4, 1fr)" }}
          justifyItems="center"
          gap={{ base: "10", md: "10", lg: "0" }}
        >
          {statsText.map((stat) => (
            <Stat.Root gap={5} alignItems="center">
              <Stat.ValueText
                fontSize={{ base: "4xl", md: "5xl" }}
                color={{ base: "teal.800", _dark: "#66b2b2" }}
                fontWeight="bold"
              >
                {inView ? (
                  <CountUp end={stat.value} duration={3} suffix={stat.symbol} />
                ) : (
                  "0" + stat.symbol
                )}
              </Stat.ValueText>
              <Stat.Label fontSize={{ base: "sm", md: "lg" }} color="gray.500">
                {stat.label}
              </Stat.Label>
            </Stat.Root>
          ))}
        </Grid>
      </Stack>
    </>
  );
};

export default Stats;
